// TODO: kill this file

export { useId as useSequentialId } from 'react';
